import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { normalizeProductImageFocus } from '../data/products';

const DEFAULT_PRODUCT_PAGE_SETTINGS = {
  backgroundImage: '',
  backgroundFocusX: 50,
  backgroundFocusY: 50,
};

const normalizeProductPageSettings = (value) => {
  const source = value && typeof value === 'object' ? value : {};
  const { x, y } = normalizeProductImageFocus(
    source.backgroundFocusX,
    source.backgroundFocusY,
  );
  return {
    backgroundImage: String(source.backgroundImage || '').trim(),
    backgroundFocusX: x,
    backgroundFocusY: y,
  };
};

const useProductPageSettings = () => {
  const [settings, setSettings] = useState(DEFAULT_PRODUCT_PAGE_SETTINGS);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, 'siteSettings', 'productPage'),
      (snapshot) => {
        setSettings(normalizeProductPageSettings(snapshot.exists() ? snapshot.data() : null));
      },
      () => setSettings(DEFAULT_PRODUCT_PAGE_SETTINGS),
    );
    return () => unsubscribe();
  }, []);

  return settings;
};

export {
  DEFAULT_PRODUCT_PAGE_SETTINGS,
  normalizeProductPageSettings,
  useProductPageSettings,
};
